import _ from "lodash";

import { ENTITY_TYPE_PROVIDER } from "../../../../../../../globalConstants";

import {
  providerClientSearch,
  followUpCalendar,
  documentSearch,
  actionItems,
  callLog,
  messageLog,
  actionLog,
  aiSummary,
} from "./constant";

export default function renderAvailablePages(userRoles, loggedInUser) {
  const activeArr = [];
  const permissions = userRoles?.permissions?.map((permission) => permission?.toLowerCase()) ?? [];
  const isProvider = loggedInUser?.entity?.entity_type_label === ENTITY_TYPE_PROVIDER;

  const addPages = (permissionList, pages) => {
    permissionList.forEach((permission, index) => {
      if (permissions.includes(permission)) {
        activeArr.push(...pages[index]);
      }
    });
  };

  if (isProvider) {
    addPages(["provider.view_providerclientstatus"], [[providerClientSearch]]);
    return activeArr;
  }

  addPages(
    ["casemanager.view_case", "provider.view_providerclientstatus"],
    [[followUpCalendar], [providerClientSearch]]
  );

  if (permissions.includes("casemanager.view_case")) {
    addPages(
      [
        "filemanager.view_document",
        "casemanager.view_actionableitems",
        "call_log.view_calllog",
        "call_log.view_smsmessage",
        "utilities.view_actionlog",
      ],
      [[documentSearch], [actionItems], [callLog], [messageLog], [actionLog]]
    );
  }

  addPages(["call_log.view_callsummary"], [[aiSummary]]);

  return _.uniqBy(activeArr, "path").sort((a, b) => a.order - b.order);
}
